var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTry = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7338_16520)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24.2673C18.6274 24.2673 24 18.8948 24 12.2673C24 5.63992 18.6274 0.267334 12 0.267334C5.37258 0.267334 0 5.63992 0 12.2673C0 18.8948 5.37258 24.2673 12 24.2673Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5097 10.072L12.4943 11.4288L14.0888 10.9118L13.1027 12.2674L14.0872 13.6242L12.4932 13.1052L11.5071 14.4608L11.5081 12.7845L9.91406 12.2655L11.5087 11.7485L11.5097 10.072Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.82198 15.6568C6.94905 15.6568 5.43067 14.1384 5.43067 12.2655C5.43067 10.3926 6.94905 8.87418 8.82198 8.87418C9.40595 8.87418 9.95542 9.02188 10.4351 9.2818C9.68256 8.54577 8.65333 8.09155 7.51764 8.09155C5.21242 8.09155 3.34375 9.96027 3.34375 12.2654C3.34375 14.5706 5.21247 16.4393 7.51764 16.4393C8.65342 16.4393 9.68261 15.9851 10.4351 15.2491C9.95542 15.5091 9.40595 15.6568 8.82198 15.6568Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7338_16520"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.267334)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTry);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/TRY.4b3781f6455ec372f4d3442e95314060.svg";